import CurrencyInput from 'react-currency-format';
import { useSelector } from 'react-redux';
import { getDictionary } from '../../assets/redux/DictionaryRedux';
interface IProps {
    value: any;
}
export default function MoneyText(props: IProps) {
    const dic = useSelector((state: any) => getDictionary(state.DicRedux));
    return (<CurrencyInput
        id="input-example"
        name="input-name"
        value={`${props.value}`}
        displayType="text"
        thousandSeparator={true}
        suffix={" "+ dic.rial+" "}
        prefix=""
    />)
}